<p-tag [severity]="item.severity" [value]="item.label | translate" *ngIf="item">
</p-tag>
